<script>
import utils from '@/utils/common';

import TaskViewDescriptionPopup from './TaskViewDescriptionPopup.vue';

export default {
  name: 'TaskViewDescriptionDispatcher',
  components: { TaskViewDescriptionPopup },
  props: {
    action: String,
    tasks: Array,
    isOpened: Boolean,
  },
  computed: {
    changedTasksWord() {
      return utils.pluralWord(this.tasks.length, 'задаче', 'задачах', 'задачах');
    },

    question() {
      return {
        new_description: 'Описание в выбранных задачах будет удалено, и в них будет установлен текущее описание. Данное действие невозможно отменить. Вы уверены, что хотите сделать это?',
        empty_description: 'Описание в выбранных задачах будет удалено. Данное действие невозможно отменить. Вы уверены, что хотите сделать это?',
      };
    },
  },
  methods: {
    async submit(value) {
      const question = value.length ? this.question.new_description : this.question.empty_description;
      const text = value.length > 0 ? 'Описание изменно' : 'Описание удалено';

      if (await this.$confirm(question)) {
        this.$emit('submit', { result: { [this.action]: value }, onSuccess: () => { this.$push({ text }); } });
      }
    },
  },
};
</script>

<template lang="pug">
TaskViewDescriptionPopup(v-if="isOpened" @submit="submit" @close="$emit('close')")
</template>

<style scoped lang="scss">

</style>
